/* eslint-disable react-hooks/rules-of-hooks */
import { Block, PrensaEngine, Link, Typography } from '@xprog/prensa'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'
import CallToActionButton from 'components/Buttons/CallToActionButton.index'
import CallToActionOutlinedButton from 'components/Buttons/CallToActionOutlinedButton.index'
import IconButton from 'components/Buttons/IconButton.index'
import DatePicker from 'components/DatePicker/DatePicker.index'
import find from 'lodash/find'
import first from 'lodash/first'
import get from 'lodash/get'
import map from 'lodash/map'
import remove from 'lodash/remove'
import { useIcon } from 'hooks/useIcon'
import { useRouter } from 'next/router'
import { FilterDataContext } from 'providers/FilterData'
import { FilterContext } from 'providers/Filter'
import React, { useContext } from 'react'
import AdsSlot from  '../Ads/Ads.Slot'

type SearchFiltersProps = {
  children?: any
  className?: string
  customLink?: any
  customLinkProps?: any
  customProps?: {
    className?: string
  }
  slotTemplateCode?: any
}

const actionButtonsStyle = {
  button: { height: '42px', width: '100%' }
}
const containerProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mb: '$4',
  p: '$3',
  width: '100%'
}
const containerDatePickerProps: PrensaEngineCSSProp = {
  borderBottom: '1px solid #e6e6e6',
  mb: '$5',
  width: '100%'
}
const containerDepartmentFilterProps: PrensaEngineCSSProp = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '$alternative',
  borderColor: '#e6e6e6',
  minWidth: '278px',
  mb: '$4',
  width: '100%',
  ' > :first-child': {
    borderTop: 'none'
  }
}
const datePickerCssProps = {
  picker: {
    container: { width: '280px', my: '$4', mb: '$1' }
  },
  label: {
    fontFamily: '$primary',
    fontSize: '18px',
    lineHeight: '21px',
    fontWeight: '400',
    ml: '$0'
  }
}
const itemDepartmentFilterProps: PrensaEngineCSSProp = {
  align: ['row', 'between', 'middle'],
  borderTop: '1px solid #e6e6e6',
  width: '100%'
}
const typographyDepartmentItemProps: PrensaEngineCSSProp = {
  align: ['row', 'left', 'middle'],
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '25px',
  letterSpacing: '0.4px',
  pl: '$3',
  py: '$2',
  m: '$0'
}
const typographyHeadlineProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '20px',
  p: '$0',
  pb: '$3',
  m: '$0'
}
const typographyLabelProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '18px',
  lineHeight: '21px',
  fontWeight: '400'
}

const InputBox = PrensaEngine.styled('input', {
  borderColor: '#BFBFBF',
  borderRadius: '$default',
  cursor: 'pointer',
  height: '20px',
  mr: '$4',
  width: '20px'
})
const SearchFilters: React.FC<SearchFiltersProps> = (props) => {
  const router = useRouter()
  const filterDataContext = useContext(FilterDataContext)
  const filterContext = useContext(FilterContext)
  const slotPolicyId = props?.slotTemplateCode
  const slotFilters = filterContext.filters[slotPolicyId] || {}
  const slotMenuItem: string = first(get(props, 'slotAutoLeftElements', [])) || ''
  const slotMenuItemId: string = slotMenuItem ? slotMenuItem.replace('contentid/', 'policy:') : ''
  const departmentList = find(get(props, 'contentData', []), { id: slotMenuItemId })
  const isFiltersDisabled = filterDataContext.loading
  const urlParams = new URLSearchParams(window.location.search)
  const searchTag = urlParams.get('tag') || ''
  const searchText = slotFilters.term !== '' ? slotFilters.term : urlParams.get('term') || ''
  const clientSlug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG

  const handleDate = (e) => {
    filterContext.updateFilter(slotPolicyId, { date: e })
  }

const handleDepartmentFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { checked: isChecked, id } = e.target
  const oldState = slotFilters.departments ?? []
  const newState = isChecked
    ? [...oldState, id]
    : oldState.filter(deptId => deptId !== id)

  filterContext.updateFilter(slotPolicyId, { departments: newState })
}

  const handleFilter = () => {
    filterContext.updateFilter(slotPolicyId, { pageStart: 0 })
    filterDataContext.loadSearchEngineData({
      dateStart: slotFilters.date ? new Date(new Date(slotFilters.date).setHours(0, 0, 0)).toISOString() : null,
      dateEnd: slotFilters.date ? new Date(new Date(slotFilters.date).setHours(23, 59, 59)).toISOString() : null,
      departments: slotFilters.departments,
      policyId: slotPolicyId,
      pageRows: slotFilters.pageRows,
      pageStart: 0,
      searchTag,
      searchText
    }, { isSearchEngine: true })
  }

  const handleClearState = () => {
    const currentUrlPath = router.asPath
    const termRegex = new RegExp('\\?term=')
    const urlHasParams = termRegex.test(currentUrlPath)
    const url = urlHasParams === false ? currentUrlPath : `${currentUrlPath.split(termRegex)[0]}`
    router.push(url)
  }

  const parseIconName = (icon) => {
    const itemName = icon.replace('Cidades', 'Cidade').replace('Política', 'Politica').replace('Opinião', 'Opiniao')
    return useIcon(`Ic${itemName}`)
  }

  return (
    <Block css={containerProps}>
      <AdsSlot type='block' componentReference='top' data={{name: 'Search Filter'}} />
      <Block css={containerDatePickerProps}>
        <Typography css={typographyHeadlineProps} as='h2'>
          FILTRO DE RESULTADOS
        </Typography>
      </Block>
      <DatePicker
        css={datePickerCssProps}
        onChange={handleDate}
        selectedDate={slotFilters.date || new Date(Date.now())}
      />
      <Typography css={typographyLabelProps} as='h2'>
        Por Editoria:
      </Typography>
      <Block css={containerDepartmentFilterProps}>
        {map(get(departmentList, 'contentData', []), (item: any) => (
          <Block css={itemDepartmentFilterProps} key={item.id}>
            <Typography css={typographyDepartmentItemProps} as='p'>
              <IconButton icon={parseIconName(item.name)} css={{ button: { mr: '$2' } }} />
              {item.name}
            </Typography>
            <InputBox
              checked={slotFilters.departments?.find((i) => i === item.id) ? true : false}
              disabled={isFiltersDisabled}
              id={item.id}
              onChange={handleDepartmentFilter}
              type='checkbox'
            />
          </Block>
        ))}
      </Block>
      <CallToActionButton
        id='buscar-avancado-botao'
        disabled={isFiltersDisabled}
        onClick={handleFilter}
        css={{
          button: {
            ...actionButtonsStyle.button,
            backgroundColor: clientSlug == 'daqui' ? '$secondaryMain' : '$primary800'
          }
        }}
      >
        Buscar
      </CallToActionButton>
      <Block css={{ mb: '$4' }} />
      <CallToActionOutlinedButton
        onClick={handleClearState}
        disabled={isFiltersDisabled}
        css={{
          button: {
            ...actionButtonsStyle.button,
            borderColor: '#E6E6E6',
            '&:disabled': { borderColor: 'rgb(167, 167, 167)', backgroundColor: '$basicWhite' }
          },
          label: {
            color: isFiltersDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
          }
        }}
      >
        Limpar Filtros
      </CallToActionOutlinedButton>
      <AdsSlot type='block' componentReference='bottom' data={{name: 'Search Filter'}} />
    </Block>
  )
}

export default SearchFilters
